import React, { useEffect, useRef } from 'react'
import Header from '../component/Header';
import Footer from '../component/Footer';
import BKT from "../assets/bkt.jpg"
import MIK from "../assets/mik.png"

export default function Partner() {
  const ref = useRef(null);
  const scrollToTop = () => {
    window.scrollTo({ top: 0, left: 0 });
  };
  useEffect(() => {
    scrollToTop();
  }, [])
  return (
    <>
      <Header />
      <div className='container mx-auto pt-32'>
        <div className="Cart mt-heading">
          <div className="flex justify-start mb-10">

            <div className="">
              <a href="/en/product/t-bluze-pa-menge-18">
                <img src={BKT} alt="T Bluzë pa mëngë" className="Image h-44" />
              </a>
            </div>

            <div className="">
              <a href="/en/product/t-bluze-pa-menge-18">
                <img src={MIK} alt="T Bluzë pa mëngë" className="Image h-44" />
              </a>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  )
}





